export const TOGGLE_EDIT_CONTENT = 'TOGGLE_EDIT_CONTENT';

export default function viewReducer(state = {
  showSidebar: false,
  showAdminSidebar: false,
  showSaveOrderDialog: false,
  showPersonalRewardsSettings: false,
  showPrivacyPopup: false,
  isUser: false,
  isRep: false,
  isAdmin: false,
  editContent: false,
  loaded: false,
  lockScroll: false,
  requestedPath: null,
  profile: { attributes: {} }
}, action) {
  switch (action.type) {
    case 'CURRENT_USER_PROFILE_FULFILLED': {
      const loginPermissions = (action.payLoad.data.attributes.permissions.can || {}).login || [];

      const isAdmin = loginPermissions.indexOf('admin_portal') !== -1;
      const isUser = loginPermissions.indexOf('web_app') !== -1;
      const isRep = loginPermissions.indexOf('team_portal') !== -1;
      const showAdminSidebar = isAdmin && state.showSidebar;

      return {
        ...state,
        profile: action.payLoad.data,
        isAdmin,
        isUser,
        isRep,
        showAdminSidebar,
        loaded: true,
      };
    }
    case 'SET_VIEWCONFIG_LOADED': {
      return {
        ...state,
        loaded: true,
      };
    }
    case 'CLEAR_PROFILE': {
      return {
        ...state,
        profile: {attributes: []},
        is_admin: false,
      };
    }
    case 'LOCK_SCROLL': {
      return {
        ...state,
        lockScroll: true
      };
    }
    case 'UNLOCK_SCROLL': {
      return {
        ...state,
        lockScroll: false
      };
    }
    case 'TOGGLE_SUGGESTIONS_DIALOG': {
      return {
        ...state,
        showSuggestions: !state.showSuggestions
      };
    }
    case 'TOGGLE_PERSONAL_REWARDS_SETTINGS_DIALOG': {
      return {
        ...state,
        showPersonalRewardsSettings: action.payLoad
      };
    }
    case TOGGLE_EDIT_CONTENT: {
      return {
        ...state,
        editContent: action.payLoad === undefined ? !state.editContent : action.payLoad
      };
    }
    case 'TOGGLE_PRIVACY_MODAL': {
      return {
        ...state,
        showPrivacyPopup: action.payLoad,
      };
    }
    case 'SAVE_REQUESTED_PATH': {
      return {
        ...state,
        requestedPath: action.payLoad
      };
    }
    case 'CLEAR_REQUESTED_PATH': {
      return {
        ...state,
        requestedPath: null
      };
    }
    default:
  }

  return {...state};
}
